var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cloudSpatialInfo" },
    [
      _c("span", { staticClass: "cloudSpatialInfo-text" }, [
        _vm._v(_vm._s(_vm.$t("cloud_files"))),
      ]),
      _c("div", { staticClass: "cloudSpatialInfo-edit" }, [
        _c(
          "div",
          { staticClass: "uploadBtn" },
          [
            _c(
              "el-button",
              { on: { click: _vm.uploadFile } },
              [
                [
                  _c("div", { staticClass: "slot" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/imgs/cloudSpace/uploadBtn.webp"),
                        alt: "",
                      },
                    }),
                    _c("span", { staticClass: "slot-text" }, [
                      _vm._v(_vm._s(_vm.$t("upload_file"))),
                    ]),
                  ]),
                ],
              ],
              2
            ),
          ],
          1
        ),
        _c("div", { staticClass: "viewUpload" }, [
          _c("img", {
            staticClass: "viewUpload-img",
            attrs: {
              src: require("@/assets/imgs/cloudSpace/storageSpace.webp"),
              alt: "",
            },
          }),
          _c("div", { staticClass: "viewUpload-info" }, [
            _c("div", { staticClass: "viewUpload-info-text" }, [
              _vm._v(" " + _vm._s(_vm.getUserUsed) + " "),
            ]),
            _c(
              "div",
              { staticClass: "viewUpload-info-progress" },
              [
                _c("el-progress", {
                  attrs: {
                    percentage:
                      Number(_vm.user?.progress) > 100
                        ? 100
                        : Number(_vm.user?.progress) || 0,
                    color: "#3986FF",
                    "show-text": false,
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c("el-upload", {
        ref: "uploadFile",
        staticClass: "upload-resource",
        staticStyle: { display: "none" },
        attrs: {
          action: "#",
          "show-file-list": false,
          "on-change": _vm.handleChange,
          "auto-upload": false,
          multiple: "",
          accept: ".3mf,.gcode,.stl,.obj,.step,.amf",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }